import ExecutionStateTransitionsService from "@src/services/ExecutionStateTransitionsService";

export const getExecutionStateTransitions = async (orgId, divId, execId) => {
  if (!orgId || !divId || !execId) {
    return null;
  }

  try {
    const executionStateTransitionsService = new ExecutionStateTransitionsService();
    const executionStateTransitions = await executionStateTransitionsService.getExecutionStateTransitions(orgId, divId, execId);
    return executionStateTransitions;
  } catch (error) {
    console.warn(`Error fetching execution state for ${execId}:`, error);
    return null;
  }
};

/**
 * Hook to get the complete execution state transitions
 * @returns {Object} - Object with getExecutionStateTransitions function
 */
const useGetExecutionStateTransitions = () => {
  return { getExecutionStateTransitions };
};

export default useGetExecutionStateTransitions;